export default {
  individual: {
    header: 'Individual Life Insurance',
    body: `<div class="title-sm">Reassurance for you and your Loved Ones.</div>
<p>Many individuals consider life insurance to be the cornerstone of a sound financial plan.
 And while no one likes to think about passing on, Life Insurance can
 relieve you of the financial worry your loved ones may face in the event of your passing. </p>
<p>Your beneficiaries will be able to use your Life Insurance policy to help pay for anything from expensive funeral
costs and estate taxes to making up for lost income or funding your child’s education. It can even be used to continue
payments on your mortgage to help ensure that the family home stays in the family.</p>
<p>At SIG & Associates, we know that choosing a Life Insurance plan is a big decision with many important factors
to consider. Our knowledgeable team of insurance professionals is committed to walking you through the process
and providing you with the best insurance solution to give you and your family the reassurance they deserve.</p>
<p><small><i>SIG & Associates provides life insurance to individuals in
Wichita Falls, Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>

<div class="title-sm">Types of Individual Life Insurance</div>

<p>SIG & Associates offers several different coverage options for your consideration including <b>term life, whole life, and more</b>.</p>
<p>Term Life – This is typically the simplest and least expensive insurance option.
Term life insurance provides coverage at a fixed rate for a specified period of time.
It’s a benefit policy that’s used primarily to cover financial responsibilities of the insured,
with the benefit to be paid only if the insured were to die during the specified term. Most term life
policies can be converted to a more permanent insurance solution such as whole life or universal life insurance.</p>
<p>There are two types of term life insurance: </p>

<ul>
<li><b>Annual Renewable Term</b> is purchased for a period of one year, with the death benefit to be paid only
if the insured were to die during that one-year term, along with the option to renew after the term period.</li>
<li><b>Level Term Life</b> guarantees a fixed premium for a given period of time, usually in terms of 10, 15, 20, or 30 years.
Your premium is based on your age and coverage options, with longer terms being more expensive.</li>
</ul>

<p>Whole Life – As the most common type of permanent insurance, a whole life policy guarantees a death benefit for the
lifetime of the insured as well as a cash value account for savings. Your premium remains constant throughout the
duration of policy while payments over and above your premium are credited to your savings, which earn a fixed rate of interest.</p>

<div class="title-sm">SIG & Associates is here for you</div>

<p>There are many things to take into account when purchasing life insurance, and changes in your life situation can
reflect changes in your insurance requirements. That’s why it’s important to carefully consider the different policy
options and ensure that you have the right solution to meet your long-term life insurance needs.</p>
<p>An insurance specialist with SIG & Associates will review your current life insurance situation
and help you design a policy to plan for the future.</p>
<p>At the end of the day, one of the biggest investments you can make is an investment in yourself. </p>
<p><small><i>As your personal situations change (i.e., marriage, birth of a child or job promotion),
so will your life insurance needs. Care should be taken to ensure this product is suitable for your long-term life
insurance needs. You should weigh any associated costs before making a purchase. Life insurance has fees and
charges associated with it that include costs of insurance that vary with such characteristics of the insured as
gender, health and age, and has additional charges for riders that customize a policy to fit your individual needs.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  group: {
    header: 'Group Life Insurance',
    body: `<div class="title-sm">Your Employees are the Backbone of Your Business</div>
<p>Having an impressive benefit package is essential for maintaining a happy and productive workforce.
Since Life Insurance is the foundation of every health package, employees look to their employer to provide
that valuable coverage not only for themselves, but also for their families.</p>
<p>At SIG & Associates, we offer a variety of flexible Group Life Insurance solutions that benefit both you and
your employees. As an employer, you can enjoy financial advantages such as income-tax deductible premiums and
Life Insurance protection at a low group rate. Group Life insurance also can contribute positively to the
productivity of your business by reducing employee turnover and strengthening employee morale and loyalty.</p>
<p>To learn more about the Group Life Insurance options available to your business,
get in touch with a specialist at SIG & Associates. Our professional staff will gather information about
your business and help design a plan that fits your needs and objectives for a desirable Group Life plan.</p>
<p><small><i>As your personal situations change (i.e., marriage, birth of a child or job promotion),
so will your life insurance needs. Care should be taken to ensure this product is suitable for your
long-term life insurance needs. You should weigh any associated costs before making a purchase.
Life insurance has fees and charges associated with it that include costs of insurance that vary with
such characteristics of the insured as gender, health and age, and has additional charges for
riders that customize a policy to fit your individual needs.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  'long-term': {
    header: 'Long-Term Care Insurance',
    body: `<div class="title-sm">Personal and Financial Protection for the Long Term.</div>
<p>For most Americans, a traditional Life and Health Insurance package is enough to keep themselves and
their families insured, but for many, additional coverage is required.
At SIG & Associates, we offer extensive coverage options that can insure the care of those who need it most.</p>
<p>ULong-Term Care Insurance (LTC) helps provide for the medical expenses of extended home health care or nursing
home costs beyond a specified period. In general, individuals who require Long-Term Care are those who can no longer
take care of themselves and are unable to perform the basic activities of daily living without assistance.</p>
<p>The costs of Long-Term Care can be quite expensive, and are typically not covered under basic Health Insurance,
Medicare, or Medicaid. Long-Term Care Insurance from SIG & Associates can protect your family’s financial
future by providing valuable coverage benefits for costs associated with:</p>

<ul>
<li>Home Care</li>
<li>Assisted Living</li>
<li>Adult Daycare</li>
<li>Hospice Care</li>
<li>Nursing Homes</li>
<li>Respite Care</li>
</ul>

<p>Individuals looking to purchase Long-Term Care Insurance must meet certain conditions in order to qualify for benefits.
Talk to an insurance professional with SIG & Associates to learn more about Long-Term Care Insurance
and whether you should add it to your current policy.</p>
<p><small><i>All guarantees and benefits of the insurance policy are backed by the claims-paying ability of the
issuing insurance company. Policy guarantees and benefits are not backed by the broker/dealer and/or insurance
agency selling the policy, nor by any of their affiliates, and none of them makes any representations or guarantees
regarding the claims-paying ability of the issuing insurance company.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  mortgage: {
    header: 'Mortgage Protection Insurance',
    body: `<div class="title-sm">Keep the Family Home in the Family</div>
<p>You’ve always been there for your family, and you want to make sure they’re taken care of after you’re gone.
In the event of your passing, family income is reduced and expenses can start to pile up,
the largest of which is usually the home mortgage.</p>
<p>Mortgage Protection Insurance from SIG & Associates is a simple and affordable way to safeguard your family
against the financial burden of an outstanding mortgage in the event of your death, by helping to pay off
the remaining balance up to a specified amount. With the right coverage, your family can
continue living in the house they’ve come to call home.</p>
<p>Talk with an insurance specialst at SIG & Associates to see if
Mortgage Protection Insurance is right for you and to discuss other Life Insurance
options to give your family the peace of mind they deserve.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  disability: {
    header: 'Disability Insurance',
    body: `<div class="title-sm">Your Biggest Asset is You</div>
<p>When it comes to protecting your assets, one of the most important things you can insure isn’t a material
object like your car or home – it’s your ability to work and earn a living. At SIG & Associates, we know
that like most people, you depend on your income to pay bills, put food on the table, and provide for your family.
But if you get sick or injured and can’t work, you’ll need to be protected in order to maintain your standard of living.</p>
<p>With disability income Insurance from SIG & Associates, you can continue to pay your bills and keep you and your
family from going into serious debt. If you can’t work as a result of injury or other illness, a disability insurance
policy will pay a portion of your income, usually between 50 and 70 percent.</p>
<p>Policies can vary greatly depending on the individual, and the duration and amount for which you are reimbursed
are determined by the nature of the disabling accident. Like life insurance, disability is purchased for a period of time,
such as a two or five-year term, and benefits will only be paid if you become disabled during the term of the policy.</p>

<p>Choosing the right disability coverage is important. In the event you become disabled, you'll want to ensure that
you and your family have enough coverage. A representative at SIG & Associates will look at the individual
factors in your life and work situation, and help design the best policy that meets your personal insurance needs.</p>
<p><small><i>SIG & Associates provides disability insurance to individuals in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  '2nd-to-die': {
    header: 'Second-To-Die Policy',
    body: `<div class="title-sm">Ensure the Future of Your Estate</div>
<p>Between physical assets and financial successes, there are many things that married couples share.
SIG & Associates knows that couples today can easily accumulate wealth in the millions,
which means hefty estate taxes in the event of either spouse’s passing. A Second-to-Die policy,
also known as Survivorship Insurance, is a type of joint insurance that covers the lives of two people,
usually married couples, where the death benefit is not paid until the death of the second insured person.</p>
<p>Under federal tax law*, you are permitted to leave an unlimited amount of personal assets to the surviving spouse,
allowing you to postpone estate taxes until the death of the second spouse. While this lets you keep personal assets,
such as home or business, within the family, it also means that your beneficiaries may be faced with
paying a large estate tax after your passing.</p>

<p>A Second-to-Die policy from SIG & Associates gives your beneficiaries the means to pay off your estate taxes without
having to liquidate the personal assets you’ve worked hard to attain. And because the policy insures more than one person,
you’ll also enjoy a lower premium, and the total cost of the insurance will be cheaper than the estate taxes your
beneficiaries will be liable to pay.</p>

<p>Due to the specialized nature of Second-to-Die insurance, some limitations may apply. It’s important to discuss
your options with an insurance specialist from SIG & Associates to
determine the right amount coverage for you and your family.</p>

<p><small><i>*Federal income tax laws are complex and subject to change.
Neither Nationwide nor its representatives give legal or tax advice. Please consult your attorney
or tax advisor for answers to specific questions. </i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  'key-person': {
    header: 'Key Person (Key Men) Insurance',
    body: `<div class="title-sm">Employees are Valuable Assets Too</div>
<p>Many companies have important key figures whose expertise and talents are crucial to maintaining profitable
and productive business operations. From the savvy and influential executive to the creative thinker behind
the company’s greatest ideas, SIG & Associates knows that some talent is simply too difficult to replace.</p>

<p>Key Person, or Key Men, Insurance provides financial support for business owners in the event that death or
permanent disability results in the loss of an employee who is essential to business operations.
This policy helps assure that business can continue as planned while you look for a suitable replacement.
In addition, it affirms the importance of the talent that the Key Person brings to your business.</p>

<p>Several business benefits are built into your Key Person Insurance policy with SIG & Associates, such as:</p>

<ul>
<li>Coverage that acts as a business asset for enhancing your company’s creditworthiness</li>
<li>Cash value of the policy that may be available to your business as a loan if needed</li>
<li>A policy that can be converted to a retirement bonus for the key employee</li>
</ul>

<p>At SIG & Associates, our professional and knowledgeable insurance specialists are sensitive to your
needs as a business owner and dedicated to providing all of your commercial insurance solutions.
Talk to a representative today to learn more about what Key Person Life Insurance can do for your business.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/lifeHelper.js